module.exports = __webpack_public_path__ + "img/home-mobile.55df26c.png?v=1791296779994";